/* eslint-disable */
// AUTO-GENERATED by scripts/apply-marzipano-hotspots.ts — do not edit manually
// Source: 02-virtual-tour/data.js
import type { SceneConfig } from './types';

/** 22 scenes, 54 link hotspots (Marzipano Tool) */
export const generatedScenes: SceneConfig[] = [
  {
    id: 'flycam-cao-toan-khu-37-5-ha',
    group: 'overview',
    order: 1,
    tilesPath: '/panoramas/flycam-cao-toan-khu-37-5-ha/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/flycam-cao-toan-khu-37-5-ha/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":-0.036341102233329536,"pitch":0.11909282876760585,"fov":1.4498257415187656},
    hotspots: [
      { yaw: 1.0169486309668478, pitch: 0.07677101309574574, targetId: 'sanh-chinh', labelKey: 'hotspots.flycam-cao-toan-khu-37-5-ha.0' },
      { yaw: 1.4113151556881558, pitch: -0.030755095949359657, targetId: 'flycam-cao-2-benh-vien', labelKey: 'hotspots.flycam-cao-toan-khu-37-5-ha.1' }
    ],
    bookingHospital: 'cih',
    useDemoTiles: false,
    marzipanoSceneId: '10-flycam__flycam-cao-toan-khu-37-5-ha__dji_20260827111659_0190_d',
  },
  {
    id: 'flycam-cao-2-benh-vien',
    group: 'overview',
    order: 2,
    tilesPath: '/panoramas/flycam-cao-2-benh-vien/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/flycam-cao-2-benh-vien/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":-0.08320199721835309,"pitch":0.19028962857432674,"fov":1.4498257415187656},
    hotspots: [
      { yaw: -0.1023090539178213, pitch: 0.5737599345664552, targetId: 'canh-quan-noi-khu-loi-di-giua-2-bv', labelKey: 'hotspots.flycam-cao-2-benh-vien.0' },
      { yaw: 0.9885834999530392, pitch: 0.44966104055123957, targetId: 'sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may', labelKey: 'hotspots.flycam-cao-2-benh-vien.1' },
      { yaw: -1.1867822256262848, pitch: 0.3171704929865591, targetId: 'sanh-chinh', labelKey: 'hotspots.flycam-cao-2-benh-vien.2' },
      { yaw: -1.4799355244126478, pitch: 0.16872290924535704, targetId: 'flycam-cao-toan-khu-37-5-ha', labelKey: 'hotspots.flycam-cao-2-benh-vien.3' }
    ],
    bookingHospital: 'cih',
    useDemoTiles: false,
    marzipanoSceneId: '9-flycam__flycam-cao-2-benh-vien__dji_20260827105212_0161_d',
  },
  {
    id: 'canh-quan-noi-khu-loi-di-giua-2-bv',
    group: 'cih',
    order: 3,
    tilesPath: '/panoramas/canh-quan-noi-khu-loi-di-giua-2-bv/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/canh-quan-noi-khu-loi-di-giua-2-bv/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":1.6109497034381555,"pitch":0.03166663288203253,"fov":1.4498257415187656},
    hotspots: [
      { yaw: 1.6080129243521357, pitch: 0.05696361254303639, targetId: 'chao-mung-quy-khach-den-voi-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh', labelKey: 'hotspots.canh-quan-noi-khu-loi-di-giua-2-bv.0' },
      { yaw: -1.5292284226816584, pitch: 0.028643627678833994, targetId: 'sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may', labelKey: 'hotspots.canh-quan-noi-khu-loi-di-giua-2-bv.1' },
      { yaw: 0.7833112781013938, pitch: -0.20688226734352888, targetId: 'flycam-cao-2-benh-vien', labelKey: 'hotspots.canh-quan-noi-khu-loi-di-giua-2-bv.2' }
    ],
    bookingHospital: 'cih',
    useDemoTiles: false,
    marzipanoSceneId: '0-cih__canh-quan-noi-khu-loi-di-giua-2-bv__cam_20260827091842_0045_d',
  },
  {
    id: 'chao-mung-quy-khach-den-voi-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh',
    group: 'cih',
    order: 4,
    tilesPath: '/panoramas/chao-mung-quy-khach-den-voi-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/chao-mung-quy-khach-den-voi-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":-0.6011700935939857,"pitch":0.0875167783684816,"fov":1.4498257415187656},
    hotspots: [
      { yaw: 0.3419177131945723, pitch: 0.3248979914270471, targetId: 'tham-quan-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh', labelKey: 'hotspots.chao-mung-quy-khach-den-voi-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh.0' },
      { yaw: 2.4512987367350654, pitch: 0.1581065517864353, targetId: 'canh-quan-noi-khu-loi-di-giua-2-bv', labelKey: 'hotspots.chao-mung-quy-khach-den-voi-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh.1' }
    ],
    bookingHospital: 'cih',
    useDemoTiles: false,
    marzipanoSceneId: '1-cih__chao-mung-quy-khach-den-voi-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh__cam_20260827091223_0036_d',
  },
  {
    id: 'tham-quan-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh',
    group: 'cih',
    order: 5,
    tilesPath: '/panoramas/tham-quan-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/tham-quan-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":-1.3717542532845783,"pitch":0.06259219888711343,"fov":1.4498257415187656},
    hotspots: [
      { yaw: 0.5229316744948829, pitch: 0.1942600972792441, targetId: 'chao-mung-quy-khach-den-voi-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh', labelKey: 'hotspots.tham-quan-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh.0' },
      { yaw: -1.720857361135728, pitch: 0.1868695367780724, targetId: 'hanh-lang-khu-kham-ngoai-tru', labelKey: 'hotspots.tham-quan-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh.1' }
    ],
    bookingHospital: 'cih',
    useDemoTiles: false,
    marzipanoSceneId: '21-cih__tham-quan-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh__cam_20260827091507_0040_d',
  },
  {
    id: 'sanh-chinh',
    group: 'cih',
    order: 6,
    tilesPath: '/panoramas/sanh-chinh/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/sanh-chinh/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":1.4596429794138341,"pitch":-0.060370179009668234,"fov":1.4498257415187656},
    hotspots: [
      { yaw: 1.1478167083680422, pitch: -0.34809919849581306, targetId: 'phong-benh-noi-tru', labelKey: 'hotspots.sanh-chinh.0' },
      { yaw: 1.7741024881374914, pitch: -0.3611076891582794, targetId: 'phong-benh-vip-suite', labelKey: 'hotspots.sanh-chinh.1' },
      { yaw: 2.185398120088479, pitch: 0.2980493198783556, targetId: 'quay-tiep-nhan-le-tan', labelKey: 'hotspots.sanh-chinh.2' },
      { yaw: 2.985801174844921, pitch: 0.03558435589555131, targetId: 'phong-cho-kham-chung', labelKey: 'hotspots.sanh-chinh.3' },
      { yaw: 2.621357191138409, pitch: -0.25360441321906535, targetId: 'hanh-lang-khu-kham-ngoai-tru', labelKey: 'hotspots.sanh-chinh.4' },
      { yaw: 0.34026532687529, pitch: 0.050067324769067056, targetId: 'phong-kham-quoc-te-van-phong-don-khach-campuchia', labelKey: 'hotspots.sanh-chinh.5' },
      { yaw: -1.6468971734147981, pitch: -0.08740009183123476, targetId: 'flycam-cao-2-benh-vien', labelKey: 'hotspots.sanh-chinh.6' }
    ],
    bookingHospital: 'cih',
    useDemoTiles: false,
    marzipanoSceneId: '8-cih__sanh-chinh__cam_20260827112737_0157_d',
  },
  {
    id: 'quay-tiep-nhan-le-tan',
    group: 'cih',
    order: 7,
    tilesPath: '/panoramas/quay-tiep-nhan-le-tan/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/quay-tiep-nhan-le-tan/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":1.0653681023132595,"pitch":-0.005177691078998237,"fov":1.4498257415187656},
    hotspots: [
      { yaw: 0.045839544737777516, pitch: 0.05367249730221246, targetId: 'phong-kham-quoc-te-van-phong-don-khach-campuchia', labelKey: 'hotspots.quay-tiep-nhan-le-tan.0' },
      { yaw: -0.7634197804244831, pitch: 0.341487650724428, targetId: 'sanh-chinh', labelKey: 'hotspots.quay-tiep-nhan-le-tan.1' },
      { yaw: -2.854073471148329, pitch: 0.11954452066822796, targetId: 'phong-cho-kham-chung', labelKey: 'hotspots.quay-tiep-nhan-le-tan.2' },
      { yaw: 2.9468464962423973, pitch: -0.343821779567584, targetId: 'hanh-lang-khu-kham-ngoai-tru', labelKey: 'hotspots.quay-tiep-nhan-le-tan.3' },
      { yaw: 1.353048327814772, pitch: -0.592453578047536, targetId: 'phong-benh-vip-suite', labelKey: 'hotspots.quay-tiep-nhan-le-tan.4' },
      { yaw: 0.6473209304527252, pitch: -0.4306046399442671, targetId: 'phong-benh-noi-tru', labelKey: 'hotspots.quay-tiep-nhan-le-tan.5' }
    ],
    bookingHospital: 'cih',
    useDemoTiles: false,
    marzipanoSceneId: '7-cih__quay-tiep-nhan-le-tan__cam_20260827112650_0154_d',
  },
  {
    id: 'phong-cho-kham-chung',
    group: 'cih',
    order: 8,
    tilesPath: '/panoramas/phong-cho-kham-chung/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/phong-cho-kham-chung/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":-1.63596851225158,"pitch":0.12800194703219248,"fov":1.4498257415187656},
    hotspots: [
      { yaw: 2.193680589695684, pitch: 0.08898739374098596, targetId: 'sanh-chinh', labelKey: 'hotspots.phong-cho-kham-chung.0' }
    ],
    bookingHospital: 'cih',
    useDemoTiles: false,
    marzipanoSceneId: '5-cih__phong-cho-kham-chung__cam_20260827123447_0163_d',
  },
  {
    id: 'hanh-lang-khu-kham-ngoai-tru',
    group: 'cih',
    order: 9,
    tilesPath: '/panoramas/hanh-lang-khu-kham-ngoai-tru/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/hanh-lang-khu-kham-ngoai-tru/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":-0.9190475441818187,"pitch":0.07766923615278643,"fov":1.4498257415187656},
    hotspots: [
      { yaw: -1.0560862824459143, pitch: 0.05152644128239103, targetId: 'tham-quan-nhung-dau-an-hinh-thanh-phat-trien-khu-y-te-ky-thuat-cao-tp-ho-chi-minh', labelKey: 'hotspots.hanh-lang-khu-kham-ngoai-tru.0' },
      { yaw: 2.0903636986390364, pitch: 0.055995378411271446, targetId: 'sanh-chinh', labelKey: 'hotspots.hanh-lang-khu-kham-ngoai-tru.1' }
    ],
    bookingHospital: 'cih',
    useDemoTiles: false,
    marzipanoSceneId: '2-cih__hanh-lang-khu-kham-ngoai-tru__cam_20260827085858_0022_d',
  },
  {
    id: 'phong-kham-quoc-te-van-phong-don-khach-campuchia',
    group: 'cih',
    order: 10,
    tilesPath: '/panoramas/phong-kham-quoc-te-van-phong-don-khach-campuchia/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/phong-kham-quoc-te-van-phong-don-khach-campuchia/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":-0.8198601816241631,"pitch":0.2790195465433616,"fov":1.4498257415187656},
    hotspots: [
      { yaw: -1.8308156484453804, pitch: 0.17977442127115673, targetId: 'sanh-chinh', labelKey: 'hotspots.phong-kham-quoc-te-van-phong-don-khach-campuchia.0' }
    ],
    bookingHospital: 'cih',
    useDemoTiles: false,
    marzipanoSceneId: '6-cih__phong-kham-quoc-te-van-phong-don-khach-campuchia__cam_20260827083906_0003_d',
  },
  {
    id: 'phong-benh-vip-suite',
    group: 'cih',
    order: 11,
    tilesPath: '/panoramas/phong-benh-vip-suite/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/phong-benh-vip-suite/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":1.4166065844022633,"pitch":0.220532368331682,"fov":1.4498257415187656},
    hotspots: [
      { yaw: -1.1972081009508386, pitch: 0.1940061563093245, targetId: 'sanh-chinh', labelKey: 'hotspots.phong-benh-vip-suite.0' },
      { yaw: -1.5262669044152446, pitch: 0.20081437332772722, targetId: 'phong-benh-noi-tru', labelKey: 'hotspots.phong-benh-vip-suite.1' }
    ],
    bookingHospital: 'cih',
    useDemoTiles: false,
    marzipanoSceneId: '4-cih__phong-benh-vip-suite__cam_20260827103305_0066_d',
  },
  {
    id: 'phong-benh-noi-tru',
    group: 'cih',
    order: 12,
    tilesPath: '/panoramas/phong-benh-noi-tru/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/phong-benh-noi-tru/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":-1.8728481573617266,"pitch":0.1536804517729795,"fov":1.4498257415187656},
    hotspots: [
      { yaw: 1.9535763312226795, pitch: 0.20363082140397815, targetId: 'phong-benh-vip-suite', labelKey: 'hotspots.phong-benh-noi-tru.0' },
      { yaw: 1.7398621786677246, pitch: 0.2269443509096547, targetId: 'sanh-chinh', labelKey: 'hotspots.phong-benh-noi-tru.1' }
    ],
    bookingHospital: 'cih',
    useDemoTiles: false,
    marzipanoSceneId: '3-cih__phong-benh-noi-tru__cam_20260827104453_0078_d',
  },
  {
    id: 'sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may',
    group: 'gia-an',
    order: 13,
    tilesPath: '/panoramas/sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":-1.703250080987356,"pitch":-0.06133938878128298,"fov":1.4498257415187656},
    hotspots: [
      { yaw: -2.329539224473052, pitch: 0.08386649546686797, targetId: 'khoa-chan-doan-hinh-anh-tham-do-chuc-nang', labelKey: 'hotspots.sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may.0' },
      { yaw: -2.1411278925517045, pitch: -0.14448195052768753, targetId: 'khoa-vltl', labelKey: 'hotspots.sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may.1' },
      { yaw: -1.7753816951290133, pitch: -0.16532607227194696, targetId: 'phong-benh-tieu-bieu-phong-doi', labelKey: 'hotspots.sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may.2' },
      { yaw: -1.7660162052714021, pitch: -0.022444559603203018, targetId: 'phong-benh-tieu-bieu-phong-don', labelKey: 'hotspots.sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may.3' },
      { yaw: -1.7684084315337554, pitch: 0.12167271015477787, targetId: 'phong-benh-tieu-bieu-phong-vip', labelKey: 'hotspots.sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may.4' },
      { yaw: -2.1381625253743266, pitch: -0.025733427660213692, targetId: 'phong-mo', labelKey: 'hotspots.sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may.5' },
      { yaw: 2.679770495340926, pitch: 0.02064049162106585, targetId: 'khoa-cap-cuu-gia-an-115', labelKey: 'hotspots.sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may.6' },
      { yaw: 1.9812370870821727, pitch: 0.042567277231649214, targetId: 'flycam-cao-2-benh-vien', labelKey: 'hotspots.sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may.7' },
      { yaw: -0.17196479043103352, pitch: -0.31027705507873016, targetId: 'lim-premier-clinic-vip-sanh-phong-kham', labelKey: 'hotspots.sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may.8' }
    ],
    bookingHospital: 'gia-an',
    useDemoTiles: false,
    marzipanoSceneId: '20-gia-an-115__sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may__cam_20260827125058_0171_d',
  },
  {
    id: 'khoa-cap-cuu-gia-an-115',
    group: 'gia-an',
    order: 14,
    tilesPath: '/panoramas/khoa-cap-cuu-gia-an-115/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/khoa-cap-cuu-gia-an-115/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":1.3695724542176215,"pitch":0.2218277295687603,"fov":1.4498257415187656},
    hotspots: [
      { yaw: -1.7109154286158486, pitch: 0.0046126742681771304, targetId: 'sanh-chinh', labelKey: 'hotspots.khoa-cap-cuu-gia-an-115.0' }
    ],
    bookingHospital: 'gia-an',
    useDemoTiles: false,
    marzipanoSceneId: '11-gia-an-115__khoa-cap-cuu-gia-an-115__cam_20260827132020_0188_d',
  },
  {
    id: 'khoa-kham-benh-hanh-lang-phong-kham',
    group: 'gia-an',
    order: 15,
    tilesPath: '/panoramas/khoa-kham-benh-hanh-lang-phong-kham/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/khoa-kham-benh-hanh-lang-phong-kham/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":-1.4795779099662507,"pitch":0.01880813855857255,"fov":1.4498257415187656},
    hotspots: [
      { yaw: -0.4129590259078473, pitch: 0.2112259441288895, targetId: 'sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may', labelKey: 'hotspots.khoa-kham-benh-hanh-lang-phong-kham.0' },
      { yaw: -2.7124245532090114, pitch: 0.04182752132291512, targetId: 'lim-premier-clinic-vip-sanh-phong-kham', labelKey: 'hotspots.khoa-kham-benh-hanh-lang-phong-kham.1' }
    ],
    bookingHospital: 'gia-an',
    useDemoTiles: false,
    marzipanoSceneId: '13-gia-an-115__khoa-kham-benh-hanh-lang-phong-kham__cam_20260827132811_0197_d',
  },
  {
    id: 'khoa-chan-doan-hinh-anh-tham-do-chuc-nang',
    group: 'gia-an',
    order: 16,
    tilesPath: '/panoramas/khoa-chan-doan-hinh-anh-tham-do-chuc-nang/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/khoa-chan-doan-hinh-anh-tham-do-chuc-nang/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":-2.0677043885519932,"pitch":0.3018508950483607,"fov":1.4498257415187656},
    hotspots: [
      { yaw: -1.2505829092824712, pitch: 0.13979075601059598, targetId: 'sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may', labelKey: 'hotspots.khoa-chan-doan-hinh-anh-tham-do-chuc-nang.0' }
    ],
    bookingHospital: 'gia-an',
    useDemoTiles: false,
    marzipanoSceneId: '12-gia-an-115__khoa-chan-doan-hinh-anh-tham-do-chuc-nang__cam_20260827151211_0336_d',
  },
  {
    id: 'khoa-vltl',
    group: 'gia-an',
    order: 17,
    tilesPath: '/panoramas/khoa-vltl/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/khoa-vltl/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":1.6981832055347459,"pitch":0.2750873270019465,"fov":1.4498257415187656},
    hotspots: [
      { yaw: -2.4458308943848124, pitch: 0.15561227834446356, targetId: 'sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may', labelKey: 'hotspots.khoa-vltl.0' }
    ],
    bookingHospital: 'gia-an',
    useDemoTiles: false,
    marzipanoSceneId: '14-gia-an-115__khoa-vltl__cam_20260827135757_0267_d',
  },
  {
    id: 'phong-mo',
    group: 'gia-an',
    order: 18,
    tilesPath: '/panoramas/phong-mo/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/phong-mo/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":-1.463826348626739,"pitch":0.07942060128173623,"fov":1.4498257415187656},
    hotspots: [
      { yaw: -1.7779214756608788, pitch: 0.08189570636036869, targetId: 'sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may', labelKey: 'hotspots.phong-mo.0' }
    ],
    bookingHospital: 'gia-an',
    useDemoTiles: false,
    marzipanoSceneId: '19-gia-an-115__phong-mo__cam_20260828092230_0402_d',
  },
  {
    id: 'lim-premier-clinic-vip-sanh-phong-kham',
    group: 'gia-an',
    order: 19,
    tilesPath: '/panoramas/lim-premier-clinic-vip-sanh-phong-kham/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/lim-premier-clinic-vip-sanh-phong-kham/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":-0.055314388391551006,"pitch":0.1198686676578209,"fov":1.4498257415187656},
    hotspots: [
      { yaw: 3.1404044371029727, pitch: 0.17912869311724933, targetId: 'khoa-kham-benh-hanh-lang-phong-kham', labelKey: 'hotspots.lim-premier-clinic-vip-sanh-phong-kham.0' },
      { yaw: 1.4290145955107754, pitch: 0.271983047187522, targetId: 'sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may', labelKey: 'hotspots.lim-premier-clinic-vip-sanh-phong-kham.1' }
    ],
    bookingHospital: 'gia-an',
    useDemoTiles: false,
    marzipanoSceneId: '15-gia-an-115__lim-premier-clinic-vip-sanh-phong-kham__cam_20260827134730_0253_d',
  },
  {
    id: 'phong-benh-tieu-bieu-phong-vip',
    group: 'gia-an',
    order: 20,
    tilesPath: '/panoramas/phong-benh-tieu-bieu-phong-vip/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/phong-benh-tieu-bieu-phong-vip/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":1.9022245587111435,"pitch":0.3150172842785359,"fov":1.4498257415187656},
    hotspots: [
      { yaw: 0.08004153732800745, pitch: 0.3047128670972796, targetId: 'sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may', labelKey: 'hotspots.phong-benh-tieu-bieu-phong-vip.0' }
    ],
    bookingHospital: 'gia-an',
    useDemoTiles: false,
    marzipanoSceneId: '18-gia-an-115__phong-benh-tieu-bieu-phong-vip__cam_20260827141721_0292_d',
  },
  {
    id: 'phong-benh-tieu-bieu-phong-don',
    group: 'gia-an',
    order: 21,
    tilesPath: '/panoramas/phong-benh-tieu-bieu-phong-don/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/phong-benh-tieu-bieu-phong-don/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":-0.9034074937945213,"pitch":0.34836882349193843,"fov":1.4498257415187656},
    hotspots: [
      { yaw: 2.985332773344701, pitch: 0.3394744326606265, targetId: 'sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may', labelKey: 'hotspots.phong-benh-tieu-bieu-phong-don.0' }
    ],
    bookingHospital: 'gia-an',
    useDemoTiles: false,
    marzipanoSceneId: '17-gia-an-115__phong-benh-tieu-bieu-phong-don__cam_20260827141002_0284_d',
  },
  {
    id: 'phong-benh-tieu-bieu-phong-doi',
    group: 'gia-an',
    order: 22,
    tilesPath: '/panoramas/phong-benh-tieu-bieu-phong-doi/tiles/{z}/{f}/{y}/{x}.jpg',
    previewPath: '/panoramas/phong-benh-tieu-bieu-phong-doi/tiles/preview.jpg',
    levels: [
      {
        "tileSize": 256,
        "size": 256,
        "fallbackOnly": true
      },
      {
        "tileSize": 512,
        "size": 512
      },
      {
        "tileSize": 512,
        "size": 1024
      },
      {
        "tileSize": 512,
        "size": 2048
      },
      {
        "tileSize": 512,
        "size": 4096
      }
    ],
    initialView: {"yaw":1.6377839327058128,"pitch":0.4624849970916287,"fov":1.4498257415187656},
    hotspots: [
      { yaw: -0.040103852474127066, pitch: 0.1912775824218258, targetId: 'sanh-chinh-khu-vuc-quay-thong-tin-thu-ngan-nha-thuoc-thang-may', labelKey: 'hotspots.phong-benh-tieu-bieu-phong-doi.0' }
    ],
    bookingHospital: 'gia-an',
    useDemoTiles: false,
    marzipanoSceneId: '16-gia-an-115__phong-benh-tieu-bieu-phong-doi__cam_20260827142242_0297_d',
  }
];
